import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const startVehicleUsage = /* GraphQL */ `mutation StartVehicleUsage($reservationId: String, $pin: String) {
  startVehicleUsage(reservationId: $reservationId, pin: $pin) {
    success
    message
    code
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartVehicleUsageMutationVariables,
  APITypes.StartVehicleUsageMutation
>;
export const endVehicleUsage = /* GraphQL */ `mutation EndVehicleUsage($reservationId: String, $pin: String) {
  endVehicleUsage(reservationId: $reservationId, pin: $pin) {
    success
    message
    code
    __typename
  }
}
` as GeneratedMutation<
  APITypes.EndVehicleUsageMutationVariables,
  APITypes.EndVehicleUsageMutation
>;
